"use strict";

var _toConsumableArray = require("/home/vadim/oskar2/oskar/work/ArangoDB/js/apps/system/_admin/aardvark/APP/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _regeneratorRuntime = require("/home/vadim/oskar2/oskar/work/ArangoDB/js/apps/system/_admin/aardvark/APP/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/vadim/oskar2/oskar/work/ArangoDB/js/apps/system/_admin/aardvark/APP/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/vadim/oskar2/oskar/work/ArangoDB/js/apps/system/_admin/aardvark/APP/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/vadim/oskar2/oskar/work/ArangoDB/js/apps/system/_admin/aardvark/APP/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _awaitAsyncGenerator = require("/home/vadim/oskar2/oskar/work/ArangoDB/js/apps/system/_admin/aardvark/APP/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/home/vadim/oskar2/oskar/work/ArangoDB/js/apps/system/_admin/aardvark/APP/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArrayCursor = exports.BatchedArrayCursor = void 0;
/**
 * ```ts
 * import type { ArrayCursor, BatchedArrayCursor } from "arangojs/cursor";
 * ```
 *
 * The "cursor" module provides cursor-related interfaces for TypeScript.
 *
 * @packageDocumentation
 */

var x3_linkedlist_1 = require("x3-linkedlist");
/**
 * The `BatchedArrayCursor` provides a batch-wise API to an {@link ArrayCursor}.
 *
 * When using TypeScript, cursors can be cast to a specific item type in order
 * to increase type safety.
 *
 * @param T - Type to use for each item. Defaults to `any`.
 *
 * @example
 * ```ts
 * const db = new Database();
 * const query = aql`FOR x IN 1..5 RETURN x`;
 * const cursor = await db.query(query) as ArrayCursor<number>;
 * const batches = cursor.batches;
 * ```
 *
 * @example
 * ```js
 * const db = new Database();
 * const query = aql`FOR x IN 1..10000 RETURN x`;
 * const cursor = await db.query(query, { batchSize: 10 });
 * for await (const batch of cursor.batches) {
 *   // Process all values in a batch in parallel
 *   await Promise.all(batch.map(
 *     value => asyncProcessValue(value)
 *   ));
 * }
 * ```
 */


var BatchedArrayCursor = /*#__PURE__*/function () {
  /**
   * @internal
   * @hidden
   */
  function BatchedArrayCursor(db, body, host, allowDirtyRead) {
    var _this3 = this;

    _classCallCheck(this, BatchedArrayCursor);

    var batches = new x3_linkedlist_1.LinkedList(body.result.length ? [new x3_linkedlist_1.LinkedList(body.result)] : []);
    this._db = db;
    this._batches = batches;
    this._id = body.id;
    this._hasMore = Boolean(body.id && body.hasMore);
    this._host = host;
    this._count = body.count;
    this._extra = body.extra;
    this._allowDirtyRead = allowDirtyRead;
    this._itemsCursor = new ArrayCursor(this, {
      get isEmpty() {
        return !batches.length;
      },

      more: function more() {
        return _this3._more();
      },
      shift: function shift() {
        var _a, _b;

        var batch = (_a = batches.first) === null || _a === void 0 ? void 0 : _a.value;

        while (batch && !batch.length) {
          batches.shift();
          batch = (_b = batches.first) === null || _b === void 0 ? void 0 : _b.value;
        }

        if (!batch) return undefined;
        var value = batch.shift();
        if (!batch.length) batches.shift();
        return value;
      }
    });
  }

  _createClass(BatchedArrayCursor, [{
    key: "_more",
    value: function () {
      var _more2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.hasMore) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _context.next = 4;
                return this._db.request({
                  method: "PUT",
                  path: "/_api/cursor/".concat(this._id),
                  host: this._host,
                  allowDirtyRead: this._allowDirtyRead
                });

              case 4:
                res = _context.sent;

                this._batches.push(new x3_linkedlist_1.LinkedList(res.body.result));

                this._hasMore = res.body.hasMore;

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _more() {
        return _more2.apply(this, arguments);
      }

      return _more;
    }()
    /**
     * An {@link ArrayCursor} providing item-wise access to the cursor result set.
     *
     * See also {@link ArrayCursor.batches}.
     */

  }, {
    key: "items",
    get: function get() {
      return this._itemsCursor;
    }
    /**
     * Additional information about the cursor.
     */

  }, {
    key: "extra",
    get: function get() {
      return this._extra;
    }
    /**
     * Total number of documents in the query result. Only available if the
     * `count` option was used.
     */

  }, {
    key: "count",
    get: function get() {
      return this._count;
    }
    /**
     * Whether the cursor has any remaining batches that haven't yet been
     * fetched. If set to `false`, all batches have been fetched and no
     * additional requests to the server will be made when consuming any
     * remaining batches from this cursor.
     */

  }, {
    key: "hasMore",
    get: function get() {
      return this._hasMore;
    }
    /**
     * Whether the cursor has more batches. If set to `false`, the cursor has
     * already been depleted and contains no more batches.
     */

  }, {
    key: "hasNext",
    get: function get() {
      return this.hasMore || Boolean(this._batches.length);
    }
    /**
     * Enables use with `for await` to deplete the cursor by asynchronously
     * yielding every batch in the cursor's remaining result set.
     *
     * **Note**: If the result set spans multiple batches, any remaining batches
     * will only be fetched on demand. Depending on the cursor's TTL and the
     * processing speed, this may result in the server discarding the cursor
     * before it is fully depleted.
     *
     * @example
     * ```js
     * const cursor = await db.query(aql`
     *   FOR user IN users
     *   FILTER user.isActive
     *   RETURN user
     * `);
     * for await (const users of cursor.batches) {
     *   for (const user of users) {
     *     console.log(user.email, user.isAdmin);
     *   }
     * }
     * ```
     */

  }, {
    key: Symbol.asyncIterator,
    value: function value() {
      var _this = this;

      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!_this.hasNext) {
                  _context2.next = 5;
                  break;
                }

                _context2.next = 3;
                return _this.next();

              case 3:
                _context2.next = 0;
                break;

              case 5:
                return _context2.abrupt("return", undefined);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
    /**
     * Loads all remaining batches from the server.
     *
     * **Warning**: This may impact memory use when working with very large
     * query result sets.
     *
     * @example
     * ```js
     * const cursor = await db.query(
     *   aql`FOR x IN 1..5 RETURN x`,
     *   { batchSize: 1 }
     * );
     * console.log(cursor.hasMore); // true
     * await cursor.batches.loadAll();
     * console.log(cursor.hasMore); // false
     * console.log(cursor.hasNext); // true
     * for await (const item of cursor) {
     *   console.log(item);
     *   // No server roundtrips necessary any more
     * }
     * ```
     */

  }, {
    key: "loadAll",
    value: function () {
      var _loadAll = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!this._hasMore) {
                  _context3.next = 5;
                  break;
                }

                _context3.next = 3;
                return this._more();

              case 3:
                _context3.next = 0;
                break;

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function loadAll() {
        return _loadAll.apply(this, arguments);
      }

      return loadAll;
    }()
    /**
     * Depletes the cursor, then returns an array containing all batches in the
     * cursor's remaining result list.
     *
     * @example
     * ```js
     * const cursor = await db.query(
     *   aql`FOR x IN 1..5 RETURN x`,
     *   { batchSize: 2 }
     * );
     * const result = await cursor.batches.all(); // [[1, 2], [3, 4], [5]]
     * console.log(cursor.hasNext); // false
     * ```
     */

  }, {
    key: "all",
    value: function () {
      var _all = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", this.map(function (batch) {
                  return batch;
                }));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function all() {
        return _all.apply(this, arguments);
      }

      return all;
    }()
    /**
     * Advances the cursor and returns all remaining values in the cursor's
     * current batch. If the current batch has already been exhausted, fetches
     * the next batch from the server and returns it, or `undefined` if the
     * cursor has been depleted.
     *
     * **Note**: If the result set spans multiple batches, any remaining batches
     * will only be fetched on demand. Depending on the cursor's TTL and the
     * processing speed, this may result in the server discarding the cursor
     * before it is fully depleted.
     *
     * @example
     * ```js
     * const cursor = await db.query(
     *   aql`FOR i IN 1..10 RETURN i`,
     *   { batchSize: 5 }
     * );
     * const firstBatch = await cursor.batches.next(); // [1, 2, 3, 4, 5]
     * await cursor.next(); // 6
     * const lastBatch = await cursor.batches.next(); // [7, 8, 9, 10]
     * console.log(cursor.hasNext); // false
     * ```
     */

  }, {
    key: "next",
    value: function () {
      var _next = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var batch, values;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(!this._batches.length && this.hasNext)) {
                  _context5.next = 5;
                  break;
                }

                _context5.next = 3;
                return this._more();

              case 3:
                _context5.next = 0;
                break;

              case 5:
                if (this._batches.length) {
                  _context5.next = 7;
                  break;
                }

                return _context5.abrupt("return", undefined);

              case 7:
                batch = this._batches.shift();

                if (batch) {
                  _context5.next = 10;
                  break;
                }

                return _context5.abrupt("return", undefined);

              case 10:
                values = _toConsumableArray(batch.values());
                batch.clear(true);
                return _context5.abrupt("return", values);

              case 13:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function next() {
        return _next.apply(this, arguments);
      }

      return next;
    }()
    /**
     * Advances the cursor by applying the `callback` function to each item in
     * the cursor's remaining result list until the cursor is depleted or
     * `callback` returns the exact value `false`. Returns a promise that
     * evalues to `true` unless the function returned `false`.
     *
     * **Note**: If the result set spans multiple batches, any remaining batches
     * will only be fetched on demand. Depending on the cursor's TTL and the
     * processing speed, this may result in the server discarding the cursor
     * before it is fully depleted.
     *
     * See also:
     * {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach | `Array.prototype.forEach`}.
     *
     * @param callback - Function to execute on each element.
     *
     * @example
     * ```js
     * const cursor = await db.query(
     *   aql`FOR x IN 1..5 RETURN x`,
     *   { batchSize: 2 }
     * );
     * const result = await cursor.batches.forEach((currentBatch) => {
     *   for (const value of currentBatch) {
     *     console.log(value);
     *   }
     * });
     * console.log(result) // true
     * console.log(cursor.hasNext); // false
     * ```
     *
     * @example
     * ```js
     * const cursor = await db.query(
     *   aql`FOR x IN 1..5 RETURN x`,
     *   { batchSize: 2 }
     * );
     * const result = await cursor.batches.forEach((currentBatch) => {
     *   for (const value of currentBatch) {
     *     console.log(value);
     *   }
     *   return false; // stop after the first batch
     * });
     * console.log(result); // false
     * console.log(cursor.hasNext); // true
     * ```
     */

  }, {
    key: "forEach",
    value: function () {
      var _forEach = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(callback) {
        var index, currentBatch, result;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                index = 0;

              case 1:
                if (!this.hasNext) {
                  _context6.next = 14;
                  break;
                }

                _context6.next = 4;
                return this.next();

              case 4:
                currentBatch = _context6.sent;
                result = callback(currentBatch, index, this);
                index++;

                if (!(result === false)) {
                  _context6.next = 9;
                  break;
                }

                return _context6.abrupt("return", result);

              case 9:
                if (!this.hasNext) {
                  _context6.next = 12;
                  break;
                }

                _context6.next = 12;
                return this._more();

              case 12:
                _context6.next = 1;
                break;

              case 14:
                return _context6.abrupt("return", true);

              case 15:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function forEach(_x) {
        return _forEach.apply(this, arguments);
      }

      return forEach;
    }()
    /**
     * Depletes the cursor by applying the `callback` function to each batch in
     * the cursor's remaining result list. Returns an array containing the
     * return values of `callback` for each batch.
     *
     * **Note**: This creates an array of all return values, which may impact
     * memory use when working with very large query result sets. Consider using
     * {@link BatchedArrayCursor.forEach}, {@link BatchedArrayCursor.reduce} or
     * {@link BatchedArrayCursor.flatMap} instead.
     *
     * See also:
     * {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map | `Array.prototype.map`}.
     *
     * @param R - Return type of the `callback` function.
     * @param callback - Function to execute on each element.
     *
     * @example
     * ```js
     * const cursor = await db.query(
     *   aql`FOR x IN 1..5 RETURN x`,
     *   { batchSize: 2 }
     * );
     * const squares = await cursor.batches.map((currentBatch) => {
     *   return currentBatch.map((value) => value ** 2);
     * });
     * console.log(squares); // [[1, 4], [9, 16], [25]]
     * console.log(cursor.hasNext); // false
     * ```
     */

  }, {
    key: "map",
    value: function () {
      var _map = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(callback) {
        var index, result, currentBatch;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                index = 0;
                result = [];

              case 2:
                if (!this.hasNext) {
                  _context7.next = 10;
                  break;
                }

                _context7.next = 5;
                return this.next();

              case 5:
                currentBatch = _context7.sent;
                result.push(callback(currentBatch, index, this));
                index++;
                _context7.next = 2;
                break;

              case 10:
                return _context7.abrupt("return", result);

              case 11:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function map(_x2) {
        return _map.apply(this, arguments);
      }

      return map;
    }()
    /**
     * Depletes the cursor by applying the `callback` function to each batch in
     * the cursor's remaining result list. Returns an array containing the
     * return values of `callback` for each batch, flattened to a depth of 1.
     *
     * **Note**: If the result set spans multiple batches, any remaining batches
     * will only be fetched on demand. Depending on the cursor's TTL and the
     * processing speed, this may result in the server discarding the cursor
     * before it is fully depleted.
     *
     * See also:
     * {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/flatMap | `Array.prototype.flatMap`}.
     *
     * @param R - Return type of the `callback` function.
     * @param callback - Function to execute on each element.
     *
     * @example
     * ```js
     * const cursor = await db.query(
     *   aql`FOR x IN 1..5 RETURN x`,
     *   { batchSize: 2 }
     * );
     * const squares = await cursor.batches.flatMap((currentBatch) => {
     *   return currentBatch.map((value) => value ** 2);
     * });
     * console.log(squares); // [1, 1, 2, 4, 3, 9, 4, 16, 5, 25]
     * console.log(cursor.hasNext); // false
     * ```
     *
     * @example
     * ```js
     * const cursor = await db.query(
     *   aql`FOR x IN 1..5 RETURN x`,
     *   { batchSize: 1 }
     * );
     * const odds = await cursor.batches.flatMap((currentBatch) => {
     *   if (currentBatch[0] % 2 === 0) {
     *     return []; // empty array flattens into nothing
     *   }
     *   return currentBatch;
     * });
     * console.logs(odds); // [1, 3, 5]
     * ```
     */

  }, {
    key: "flatMap",
    value: function () {
      var _flatMap = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(callback) {
        var index, result, currentBatch, value;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                index = 0;
                result = [];

              case 2:
                if (!this.hasNext) {
                  _context8.next = 11;
                  break;
                }

                _context8.next = 5;
                return this.next();

              case 5:
                currentBatch = _context8.sent;
                value = callback(currentBatch, index, this);

                if (Array.isArray(value)) {
                  result.push.apply(result, _toConsumableArray(value));
                } else {
                  result.push(value);
                }

                index++;
                _context8.next = 2;
                break;

              case 11:
                return _context8.abrupt("return", result);

              case 12:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function flatMap(_x3) {
        return _flatMap.apply(this, arguments);
      }

      return flatMap;
    }()
  }, {
    key: "reduce",
    value: function () {
      var _reduce = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(reducer, initialValue) {
        var index, value, currentBatch;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                index = 0;

                if (this.hasNext) {
                  _context9.next = 3;
                  break;
                }

                return _context9.abrupt("return", initialValue);

              case 3:
                if (!(initialValue === undefined)) {
                  _context9.next = 8;
                  break;
                }

                _context9.next = 6;
                return this.next();

              case 6:
                initialValue = _context9.sent;
                index += 1;

              case 8:
                value = initialValue;

              case 9:
                if (!this.hasNext) {
                  _context9.next = 17;
                  break;
                }

                _context9.next = 12;
                return this.next();

              case 12:
                currentBatch = _context9.sent;
                value = reducer(value, currentBatch, index, this);
                index++;
                _context9.next = 9;
                break;

              case 17:
                return _context9.abrupt("return", value);

              case 18:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function reduce(_x4, _x5) {
        return _reduce.apply(this, arguments);
      }

      return reduce;
    }()
    /**
     * Drains the cursor and frees up associated database resources.
     *
     * This method has no effect if all batches have already been consumed.
     *
     * @example
     * ```js
     * const cursor1 = await db.query(aql`FOR x IN 1..5 RETURN x`);
     * console.log(cursor1.hasMore); // false
     * await cursor1.kill(); // no effect
     *
     * const cursor2 = await db.query(
     *   aql`FOR x IN 1..5 RETURN x`,
     *   { batchSize: 2 }
     * );
     * console.log(cursor2.hasMore); // true
     * await cursor2.kill(); // cursor is depleted
     * ```
     */

  }, {
    key: "kill",
    value: function () {
      var _kill = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        var _this4 = this;

        var _iterator, _step, batch;

        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (this._batches.length) {
                  _iterator = _createForOfIteratorHelper(this._batches.values());

                  try {
                    for (_iterator.s(); !(_step = _iterator.n()).done;) {
                      batch = _step.value;
                      batch.clear();
                    }
                  } catch (err) {
                    _iterator.e(err);
                  } finally {
                    _iterator.f();
                  }

                  this._batches.clear();
                }

                if (this.hasNext) {
                  _context10.next = 3;
                  break;
                }

                return _context10.abrupt("return", undefined);

              case 3:
                return _context10.abrupt("return", this._db.request({
                  method: "DELETE",
                  path: "/_api/cursor/".concat(this._id)
                }, function () {
                  _this4._hasMore = false;
                  return undefined;
                }));

              case 4:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function kill() {
        return _kill.apply(this, arguments);
      }

      return kill;
    }()
  }]);

  return BatchedArrayCursor;
}();

exports.BatchedArrayCursor = BatchedArrayCursor;
/**
 * The `ArrayCursor` type represents a cursor returned from a
 * {@link Database.query}.
 *
 * When using TypeScript, cursors can be cast to a specific item type in order
 * to increase type safety.
 *
 * See also {@link BatchedArrayCursor}.
 *
 * @param T - Type to use for each item. Defaults to `any`.
 *
 * @example
 * ```ts
 * const db = new Database();
 * const query = aql`FOR x IN 1..5 RETURN x`;
 * const result = await db.query(query) as ArrayCursor<number>;
 * ```
 *
 * @example
 * ```js
 * const db = new Database();
 * const query = aql`FOR x IN 1..10 RETURN x`;
 * const cursor = await db.query(query);
 * for await (const value of cursor) {
 *   // Process each value asynchronously
 *   await processValue(value);
 * }
 * ```
 */

var ArrayCursor = /*#__PURE__*/function () {
  function ArrayCursor(batchedCursor, view) {
    _classCallCheck(this, ArrayCursor);

    this._batches = batchedCursor;
    this._view = view;
  }
  /**
   * A {@link BatchedArrayCursor} providing batch-wise access to the cursor
   * result set.
   *
   * See also {@link BatchedArrayCursor.items}.
   */


  _createClass(ArrayCursor, [{
    key: "batches",
    get: function get() {
      return this._batches;
    }
    /**
     * Additional information about the cursor.
     */

  }, {
    key: "extra",
    get: function get() {
      return this.batches.extra;
    }
    /**
     * Total number of documents in the query result. Only available if the
     * `count` option was used.
     */

  }, {
    key: "count",
    get: function get() {
      return this.batches.count;
    }
    /**
     * Whether the cursor has more values. If set to `false`, the cursor has
     * already been depleted and contains no more items.
     */

  }, {
    key: "hasNext",
    get: function get() {
      return this.batches.hasNext;
    }
    /**
     * Enables use with `for await` to deplete the cursor by asynchronously
     * yielding every value in the cursor's remaining result set.
     *
     * **Note**: If the result set spans multiple batches, any remaining batches
     * will only be fetched on demand. Depending on the cursor's TTL and the
     * processing speed, this may result in the server discarding the cursor
     * before it is fully depleted.
     *
     * @example
     * ```js
     * const cursor = await db.query(aql`
     *   FOR user IN users
     *   FILTER user.isActive
     *   RETURN user
     * `);
     * for await (const user of cursor) {
     *   console.log(user.email, user.isAdmin);
     * }
     * ```
     */

  }, {
    key: Symbol.asyncIterator,
    value: function value() {
      var _this2 = this;

      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                if (!_this2.hasNext) {
                  _context11.next = 5;
                  break;
                }

                _context11.next = 3;
                return _this2.next();

              case 3:
                _context11.next = 0;
                break;

              case 5:
                return _context11.abrupt("return", undefined);

              case 6:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }))();
    }
    /**
     * Depletes the cursor, then returns an array containing all values in the
     * cursor's remaining result list.
     *
     * @example
     * ```js
     * const cursor = await db.query(aql`FOR x IN 1..5 RETURN x`);
     * const result = await cursor.all(); // [1, 2, 3, 4, 5]
     * console.log(cursor.hasNext); // false
     * ```
     */

  }, {
    key: "all",
    value: function () {
      var _all2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                return _context12.abrupt("return", this.batches.flatMap(function (v) {
                  return v;
                }));

              case 1:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function all() {
        return _all2.apply(this, arguments);
      }

      return all;
    }()
    /**
     * Advances the cursor and returns the next value in the cursor's remaining
     * result list, or `undefined` if the cursor has been depleted.
     *
     * **Note**: If the result set spans multiple batches, any remaining batches
     * will only be fetched on demand. Depending on the cursor's TTL and the
     * processing speed, this may result in the server discarding the cursor
     * before it is fully depleted.
     *
     * @example
     * ```js
     * const cursor = await db.query(aql`FOR x IN 1..3 RETURN x`);
     * const one = await cursor.next(); // 1
     * const two = await cursor.next(); // 2
     * const three = await cursor.next(); // 3
     * const empty = await cursor.next(); // undefined
     * ```
     */

  }, {
    key: "next",
    value: function () {
      var _next2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                if (!(this._view.isEmpty && this.batches.hasMore)) {
                  _context13.next = 5;
                  break;
                }

                _context13.next = 3;
                return this._view.more();

              case 3:
                _context13.next = 0;
                break;

              case 5:
                if (!this._view.isEmpty) {
                  _context13.next = 7;
                  break;
                }

                return _context13.abrupt("return", undefined);

              case 7:
                return _context13.abrupt("return", this._view.shift());

              case 8:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function next() {
        return _next2.apply(this, arguments);
      }

      return next;
    }()
    /**
     * Advances the cursor by applying the `callback` function to each item in
     * the cursor's remaining result list until the cursor is depleted or
     * `callback` returns the exact value `false`. Returns a promise that
     * evalues to `true` unless the function returned `false`.
     *
     * **Note**: If the result set spans multiple batches, any remaining batches
     * will only be fetched on demand. Depending on the cursor's TTL and the
     * processing speed, this may result in the server discarding the cursor
     * before it is fully depleted.
     *
     * See also:
     * {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach | `Array.prototype.forEach`}.
     *
     * @param callback - Function to execute on each element.
     *
     * @example
     * ```js
     * const cursor = await db.query(aql`FOR x IN 1..5 RETURN x`);
     * const result = await cursor.forEach((currentValue) => {
     *   console.log(currentValue);
     * });
     * console.log(result) // true
     * console.log(cursor.hasNext); // false
     * ```
     *
     * @example
     * ```js
     * const cursor = await db.query(aql`FOR x IN 1..5 RETURN x`);
     * const result = await cursor.forEach((currentValue) => {
     *   console.log(currentValue);
     *   return false; // stop after the first item
     * });
     * console.log(result); // false
     * console.log(cursor.hasNext); // true
     * ```
     */

  }, {
    key: "forEach",
    value: function () {
      var _forEach2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(callback) {
        var index, value, result;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                index = 0;

              case 1:
                if (!this.hasNext) {
                  _context14.next = 11;
                  break;
                }

                _context14.next = 4;
                return this.next();

              case 4:
                value = _context14.sent;
                result = callback(value, index, this);
                index++;

                if (!(result === false)) {
                  _context14.next = 9;
                  break;
                }

                return _context14.abrupt("return", result);

              case 9:
                _context14.next = 1;
                break;

              case 11:
                return _context14.abrupt("return", true);

              case 12:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function forEach(_x6) {
        return _forEach2.apply(this, arguments);
      }

      return forEach;
    }()
    /**
     * Depletes the cursor by applying the `callback` function to each item in
     * the cursor's remaining result list. Returns an array containing the
     * return values of `callback` for each item.
     *
     * **Note**: This creates an array of all return values, which may impact
     * memory use when working with very large query result sets. Consider using
     * {@link ArrayCursor.forEach}, {@link ArrayCursor.reduce} or
     * {@link ArrayCursor.flatMap} instead.
     *
     * See also:
     * {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map | `Array.prototype.map`}.
     *
     * @param R - Return type of the `callback` function.
     * @param callback - Function to execute on each element.
     *
     * @example
     * ```js
     * const cursor = await db.query(aql`FOR x IN 1..5 RETURN x`);
     * const squares = await cursor.map((currentValue) => {
     *   return currentValue ** 2;
     * });
     * console.log(squares); // [1, 4, 9, 16, 25]
     * console.log(cursor.hasNext); // false
     * ```
     */

  }, {
    key: "map",
    value: function () {
      var _map2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(callback) {
        var index, result, value;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                index = 0;
                result = [];

              case 2:
                if (!this.hasNext) {
                  _context15.next = 10;
                  break;
                }

                _context15.next = 5;
                return this.next();

              case 5:
                value = _context15.sent;
                result.push(callback(value, index, this));
                index++;
                _context15.next = 2;
                break;

              case 10:
                return _context15.abrupt("return", result);

              case 11:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function map(_x7) {
        return _map2.apply(this, arguments);
      }

      return map;
    }()
    /**
     * Depletes the cursor by applying the `callback` function to each item in
     * the cursor's remaining result list. Returns an array containing the
     * return values of `callback` for each item, flattened to a depth of 1.
     *
     * **Note**: If the result set spans multiple batches, any remaining batches
     * will only be fetched on demand. Depending on the cursor's TTL and the
     * processing speed, this may result in the server discarding the cursor
     * before it is fully depleted.
     *
     * See also:
     * {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/flatMap | `Array.prototype.flatMap`}.
     *
     * @param R - Return type of the `callback` function.
     * @param callback - Function to execute on each element.
     *
     * @example
     * ```js
     * const cursor = await db.query(aql`FOR x IN 1..5 RETURN x`);
     * const squares = await cursor.flatMap((currentValue) => {
     *   return [currentValue, currentValue ** 2];
     * });
     * console.log(squares); // [1, 1, 2, 4, 3, 9, 4, 16, 5, 25]
     * console.log(cursor.hasNext); // false
     * ```
     *
     * @example
     * ```js
     * const cursor = await db.query(aql`FOR x IN 1..5 RETURN x`);
     * const odds = await cursor.flatMap((currentValue) => {
     *   if (currentValue % 2 === 0) {
     *     return []; // empty array flattens into nothing
     *   }
     *   return currentValue; // or [currentValue]
     * });
     * console.logs(odds); // [1, 3, 5]
     * ```
     */

  }, {
    key: "flatMap",
    value: function () {
      var _flatMap2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(callback) {
        var index, result, value, item;
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                index = 0;
                result = [];

              case 2:
                if (!this.hasNext) {
                  _context16.next = 11;
                  break;
                }

                _context16.next = 5;
                return this.next();

              case 5:
                value = _context16.sent;
                item = callback(value, index, this);

                if (Array.isArray(item)) {
                  result.push.apply(result, _toConsumableArray(item));
                } else {
                  result.push(item);
                }

                index++;
                _context16.next = 2;
                break;

              case 11:
                return _context16.abrupt("return", result);

              case 12:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function flatMap(_x8) {
        return _flatMap2.apply(this, arguments);
      }

      return flatMap;
    }()
  }, {
    key: "reduce",
    value: function () {
      var _reduce2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(reducer, initialValue) {
        var index, _value, value, item;

        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                index = 0;

                if (this.hasNext) {
                  _context17.next = 3;
                  break;
                }

                return _context17.abrupt("return", initialValue);

              case 3:
                if (!(initialValue === undefined)) {
                  _context17.next = 9;
                  break;
                }

                _context17.next = 6;
                return this.next();

              case 6:
                _value = _context17.sent;
                initialValue = _value;
                index += 1;

              case 9:
                value = initialValue;

              case 10:
                if (!this.hasNext) {
                  _context17.next = 18;
                  break;
                }

                _context17.next = 13;
                return this.next();

              case 13:
                item = _context17.sent;
                value = reducer(value, item, index, this);
                index++;
                _context17.next = 10;
                break;

              case 18:
                return _context17.abrupt("return", value);

              case 19:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function reduce(_x9, _x10) {
        return _reduce2.apply(this, arguments);
      }

      return reduce;
    }()
    /**
     * Kills the cursor and frees up associated database resources.
     *
     * This method has no effect if all batches have already been fetched.
     *
     * @example
     * ```js
     * const cursor1 = await db.query(aql`FOR x IN 1..5 RETURN x`);
     * console.log(cursor1.hasMore); // false
     * await cursor1.kill(); // no effect
     *
     * const cursor2 = await db.query(
     *   aql`FOR x IN 1..5 RETURN x`,
     *   { batchSize: 2 }
     * );
     * console.log(cursor2.hasMore); // true
     * await cursor2.kill(); // cursor is depleted
     * ```
     */

  }, {
    key: "kill",
    value: function () {
      var _kill2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18() {
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                return _context18.abrupt("return", this.batches.kill());

              case 1:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function kill() {
        return _kill2.apply(this, arguments);
      }

      return kill;
    }()
  }]);

  return ArrayCursor;
}();

exports.ArrayCursor = ArrayCursor;